import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The old per-connector detail page is now the systems drawer — preserve
 * existing deep links by forwarding them to ?open on the systems page.
 */
export const Route = createFileRoute('/_protected/t/$tenantId/connectors/$connectorId')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/t/$tenantId/connectors',
      params: { tenantId: params.tenantId },
      search: { open: params.connectorId },
      replace: true,
    });
  },
});
